import React, { useState, useEffect } from "react";
import FormInputStyle5 from "../../UIElements/FormInput5";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormButtonStyle4 from "../../UIElements/FormButton";
import Header from "../Header/header";
import callApi from "../../../../utility/apiCaller"; // ✅ make sure path is correct
import { useDispatch, useSelector } from "react-redux";
import {
  setEmendateUrl,
  setOpportunityId,
  setOpportunityName,
} from "../../../../store/app/aaSlice";
import { CloudSnow } from "lucide-react";
import { add } from "lodash";
import getStateFromPincode from "../../Utils/stateMapperfnction";
import StickyCtaBar from "../../UIElements/StickyCtaBar";

const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

const mapLeadResponseToRequest = (leadResponse) => {
  if (!leadResponse || typeof leadResponse !== "object") return {};

  const { _id, ...rest } = leadResponse;

  return {
    id: _id, // transform _id → id
    ...rest,
  };
};

// generic retry wrapper
const withRetry = async (fn, retries = 3, delay = 1000) => {
  let attempt = 0;
  while (attempt < retries) {
    try {
      return await fn();
    } catch (err) {
      attempt++;
      if (attempt >= retries) throw err;
      console.warn(`Retrying... attempt ${attempt}`);
      await new Promise((res) => setTimeout(res, delay * attempt)); // backoff
    }
  }
};

function WorkDetailsForm({
  setCurrentStep,
  setAddressState,
  // lead_Id,
  //leadId = "68b16603596d4397307eccb3",
  addressState,
}) {
  const [workAddress1, setWorkAddress1] = useState("");
  const [workAddress2, setWorkAddress2] = useState("");
  const [workPincode, setWorkPincode] = useState("");
  const [pincodeValidation, setpincodeValidation] = useState(false);
  const [workCity, setWorkCity] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [state, setState] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);

  const user = useSelector((state) => state.app.user);
  const aaSlice = useSelector((state) => state?.aa);
  //console.log(aaSlice);
  const appId = aaSlice?.appId;
  const client_leadId = aaSlice?.leadId;
  const responseId = aaSlice?.responseId;

  const lead_Id = aaSlice?.internalLeadId;

  const dispatch = useDispatch();

  const validateForm = () => {
    let newErrors = {};

    if (!workAddress1.trim()) newErrors.workAddress1 = "Required";
    if (!workAddress2.trim()) newErrors.workAddress2 = "Required";
    if (!streetAddress.trim()) newErrors.streetAddress = "Required";
    if (!workCity.trim()) newErrors.workCity = "Required";
    if (!state.trim()) newErrors.state = "Required";
    if (!workPincode.match(/^\d{6}$/))
      newErrors.workPincode = "Enter 6-digit pincode";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const allValid =
      workAddress1.trim() &&
      (!errors.workAddress1 || errors.workAddress1 === false) &&
      workAddress2.trim() &&
      (!errors.workAddress2 || errors.workAddress2 === false) &&
      streetAddress.trim() &&
      (!errors.streetAddress || errors.streetAddress === false) &&
      workCity.trim() &&
      (!errors.workCity || errors.workCity === false) &&
      state.trim() &&
      (!errors.state || errors.state === false) &&
      workPincode.match(/^\d{6}$/) &&
      (!errors.workPincode || errors.workPincode === false);

    setIsFormValid(!!allValid);
  }, [
    workAddress1,
    errors.workAddress1,
    workAddress2,
    errors.workAddress2,
    streetAddress,
    errors.streetAddress,
    workCity,
    errors.workCity,
    state,
    errors.state,
    workPincode,
    errors.workPincode,
  ]);

  // Helper function to call API with retry and a custom validation function
  const callApiWithRetryAndTest = async (
    apiFunc,
    retries,
    delay,
    testFunc,
    errorMsg
  ) => {
    return await withRetry(
      async () => {
        const res = await apiFunc();
        //console.log(res);
        if (testFunc && !testFunc(res)) {
          throw new Error(errorMsg || "Validation failed");
        }
        return res;
      },
      retries,
      delay
    );
  };

  const handlePincodeChange = async (value) => {
    value = value.replace(/\D/g, ""); // allow only digits

    if (/^\d{0,6}$/.test(value)) {
      // Prevent first digit being 0 if there's at least one digit
      if (value.length > 0 && value[0] === "0") {
        return; // ignore input if first digit is 0
      }

      setWorkPincode(value); // always update input field

      if (errors.workPincode) {
        setErrors((prev) => ({ ...prev, workPincode: false }));
      }

      if (value.length === 6) {
        setpincodeValidation(true); // start loading state

        try {
          // ✅ call your backend API
          const response = await callApi(`v1/util/${value}`, "get", {}, "core");

          if (!response.success) {
            setErrors((prev) => ({ ...prev, workPincode: true }));
          } else {
            setWorkCity(response.city || ""); // ✅ only set city
            setState(getStateFromPincode(value) || ""); // ✅ only set state
            setErrors((prev) => ({ ...prev, workPincode: false }));
          }
        } catch (error) {
          console.error("Pincode validation error:", error);
          setErrors((prev) => ({ ...prev, workPincode: true }));
        } finally {
          setpincodeValidation(false); // end loading state
        }
      }
    }
  };

  const handleClickNext = async () => {
    if (!validateForm()) return;

    setLoading(true);

    const updatedAddressState = {
      work_address1: workAddress1,
      work_address2: workAddress2,
      street_address: streetAddress,
      work_pincode: workPincode,
      work_city: workCity,
      work_state: state,
    };

    setAddressState((prev) => ({ ...prev, ...updatedAddressState }));

    console.log(addressState, updatedAddressState);

    try {
      // 1️⃣ Update lead
      const leadRes = await callApiWithRetryAndTest(
        () =>
          callApi(
            `v1/lead/${lead_Id}/update-lead-new`,
            "post",
            { lead: { ...addressState, ...updatedAddressState } },
            "core",
            user?.token ||
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
          ),
        3,
        1000,
        (res) => res?.status === "Success", // test function for lead
        "❌ Update lead failed"
      );

      const dataToSend = mapLeadResponseToRequest(leadRes.data.lead);

      // 2️⃣ Update application
      // Simulate updateRes as success for now
      // 1️⃣ Update Application
      let updateRes = await callApiWithRetryAndTest(
        () =>
          callApi(
            `v1/lender/update-application?lender_id=67b82660c4058e568491673c`,
            "post",
            {
              id: lead_Id,
              lenderResponseID: responseId,
              dmi_lead_id: client_leadId,
              application_id: appId,
            },
            "loan"
          ),
        3,
        5000,
        (res) => {
          //console.log("🔍 API Response:", res);
          return (
            res?.data?.statuscode === "200" &&
            res?.data?.body?.status === "success" &&
            (res?.data?.body?.description?.trim?.() === "success" ||
              res?.data?.body?.["description "]?.trim?.() === "success")
          );
        }
      );

      if (updateRes?.data?.body?.status !== "success") {
        throw new Error("❌ Update application failed");
      }
      //console.log("✅ Update Application Success");

      // 2️⃣ Get Address Triangulation Callback
      const callbackListRes = await callApiWithRetryAndTest(
        () =>
          callApi(
            `v1/callback/list`,
            "post",
            {
              filters: {
                event: "Address_Triangulation_Callback",
                applicationid: appId,
              },
            },
            "loan-service"
          ),
        6,
        5000,
        (res) =>
          res?.status === "Success" && res?.data?.callbackList?.length > 0,
        "❌ No callbacks found"
      );

      const callbackItem = callbackListRes.data.callbackList[0];
      // if (callbackItem.decision === "In Progress") {
      //   setCurrentStep("cpv");
      //   return;
      // }
      console.log("✅ Decision Approved");

      // 3️⃣ Call RFC API
      const rfcRes = await callApiWithRetryAndTest(
        () =>
          callApi(
            `v1/lender/rfc_conversion_api`,
            "post",
            {
              lenderResponseID: responseId,
              dmi_lead_id: client_leadId,
            },
            "loan"
          ),
        1,
        1500,
        (res) => res?.status === "Success",
        "❌ RFC callback failed"
      );
      console.log("✅ RFC Conversion Success");

      // 4️⃣ Get Opportunity Callback
      const OpportunityCallback = await callApiWithRetryAndTest(
        () =>
          callApi(
            `v1/callback/list`,
            "post",
            {
              filters: {
                event: "Opportunity_Callback",
                applicationid: appId,
              },
            },
            "loan-service"
          ),
        6,
        5000,
        (res) =>
          res?.status === "Success" && res?.data?.callbackList?.length > 0,
        "❌ No Opportunity callback found"
      );

      const callbackItemOpp = OpportunityCallback.data.callbackList[0];
      if (!callbackItemOpp?.opportunityid) {
        throw new Error("❌ No Opportunity ID found");
      }
      dispatch(setOpportunityId(callbackItemOpp?.opportunityid));
      dispatch(setOpportunityName(callbackItemOpp.raw_data?.opportunityname));
      console.log("✅ Opportunity Callback Success");

      // 5️⃣ Call E-Mandate API
      let EmandateCallback = await callApiWithRetryAndTest(
        () =>
          callApi(
            `v1/lender/emandate_service`,
            "post",
            {
              lenderResponseID: responseId,
              dmi_opportunityid: callbackItemOpp?.opportunityid,
              application_id: appId,
              dmi_lead_id: client_leadId,
              id: lead_Id,
            },
            "loan"
          ),
        3,
        1500,
        (res) => res?.data?.statuscode === 200 && res?.data?.body?.emandateurl,
        "❌ E-Mandate callback failed"
      );

      // EmandateCallback = {
      //   status: "Success",
      //   data: {
      //     statuscode: 200,
      //     body: {
      //       opportunityid: "0069H00000DNwa6QAD",
      //       applicationid: "68827bdb55a5aa656ebJ7867",
      //       emandateurl:
      //         "https://dminachuat.dmifinance.in/V4/?key=68a6e8114c82e",
      //       opportunityname: "DMI0051305837",
      //     },
      //   },
      // };
      if (EmandateCallback?.data?.body?.emandateurl) {
        console.log("✅ E-Mandate Success, redirecting...");
        await callApiWithRetryAndTest(
          () =>
            callApi(
              `v1/lead/${lead_Id}/update-lead-new`,
              "post",
              {
                lead: {
                  is_workaddress_completed: true,
                  steps_completed: 12,
                  dmi_opportunityid: callbackItemOpp?.opportunityid,
                  dmi_opportunityName: callbackItemOpp?.opportunityname,
                  emandateurl: EmandateCallback?.data?.body?.emandateurl,
                },
              },
              "core",
              user?.token ||
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
            ),
          3,
          1000,
          (res) => res?.status === "Success", // test function for lead
          "❌ Update lead failed"
        );
        //setCurrentStep((prev) => prev + 2);
        dispatch(setEmendateUrl(EmandateCallback?.data?.body?.emandateurl));
        window.location.href = EmandateCallback.data.body.emandateurl; //testing
      } else {
        throw new Error("❌ No E-Mandate URL returned");
      }

      // ✅ Move to next step only after all success
      //setCurrentStep((prev) => prev + 1); testing purpose commited
      console.log("✅ All steps completed successfully, moving to next step");
    } catch (error) {
      console.error("Error in API flow:", error);
    } finally {
      setLoading(true);
    }
  };

  return (
    <>
    <div className="flex flex-col font-atkinson min-h-[100dvh] w-full pb-[120px] overflow-hidden max-w-[400px] px-3 px-4-340">
      <Header />
      <h2 className="dm-type-header mt-2 ml-3 mb-2">
        Work Details
      </h2>

      <FormInputStyle5
        // isSearchIconReq={true}
        label="Work Address 1"
        type="text"
        value={workAddress1}
        onChange={(e) => setWorkAddress1(e.target.value)}
        isValid={!errors.workAddress1}
        error={errors.workAddress1}
        className="max-w-[340px] mx-auto w-full"
      />

      <FormInputStyle5
        // isSearchIconReq={true}
        label="Work Address 2"
        type="text"
        value={workAddress2}
        onChange={(e) => setWorkAddress2(e.target.value)}
        isValid={!errors.workAddress2}
        error={errors.workAddress2}
        className="max-w-[340px] mx-auto w-full"
      />
      <FormInputStyle5
        label="Street Address"
        type="text"
        value={streetAddress}
        onChange={(e) => setStreetAddress(e.target.value)}
        isValid={!errors.streetAddress}
        error={errors.streetAddress}
        className="max-w-[340px] mx-auto w-full"
      />

      <FormInputStyle4
        label="Work Pin Code"
        value={workPincode}
        onChange={(e) => handlePincodeChange(e.target.value)}
        onBlur={() => {
          if (!workPincode.match(/^\d{6}$/)) {
            setErrors((prev) => ({ ...prev, workPincode: true }));
          }
        }}
        isValid={!errors.workPincode}
        errorMessage="Enter 6-digit pincode"
        tick={workPincode.length === 6 && !errors.workPincode}
        loading={pincodeValidation}
      />

      <FormInputStyle5
        // isSearchIconReq={true}
        label="Work City"
        type="text"
        value={workCity}
        onChange={(e) => setWorkCity(e.target.value)}
        isValid={!errors.workCity}
        error={errors.workCity}
        className="max-w-[340px] mx-auto w-full"
      />
      <FormInputStyle5
        label="Work State"
        type="text"
        readonly
        value={state}
        onChange={(e) => {
          const value = e.target.value;
          setState(value);

          // ✅ check case-insensitive match
          const matchedState = indianStates.find(
            (s) => s.toLowerCase() === value.toLowerCase()
          );

          if (value && !matchedState) {
            setErrors((prev) => ({ ...prev, state: true }));
          } else {
            setErrors((prev) => ({ ...prev, state: false }));
            if (matchedState) {
              // Auto-correct to proper case
              setState(matchedState);
            }
          }
        }}
        readOnly={!!state}
        isValid={!errors.state}
        error={errors.state}
        errorMessage={"Select a valid state"}
        className="max-w-[340px] mx-auto w-full"
      />

    </div>
    <StickyCtaBar>
      <FormButtonStyle4
        text="Next"
        isLoading={isLoading}
        disabled={!isFormValid || pincodeValidation}
        onClick={handleClickNext}
      />
    </StickyCtaBar>
    </>
  );
}

export default WorkDetailsForm;
